import { useEffect, useMemo, useState } from 'react'
import { subscribeMaterials, subscribeProductCosts } from '../services/products'
import type { Material, ProductCost } from '../types'

/**
 * Hammaddeler ve ürün maliyetleri (18 Eki 2026), canlı. Yalnız patron için
 * açılıyor (enabled): tabloları başkası okuyamıyor, boşuna abone olmasın.
 */
export function useCosts(tenantId: string | null | undefined, enabled: boolean) {
  const [materials, setMaterials] = useState<Material[]>([])
  const [costs, setCosts] = useState<ProductCost[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!tenantId || !enabled) return
    const onError = (e: Error) => {
      console.error('[maliyet]', e)
      setError(e.message)
    }
    const offM = subscribeMaterials(tenantId, setMaterials, onError)
    const offC = subscribeProductCosts(tenantId, setCosts, onError)
    return () => {
      offM()
      offC()
    }
  }, [tenantId, enabled])

  const materialMap = useMemo(() => new Map(materials.map((m) => [m.id, m])), [materials])
  const costMap = useMemo(() => new Map(costs.map((c) => [c.productId, c])), [costs])

  return { materials, materialMap, costMap, error }
}
